import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { convertSymbolCodes } from "../../../Utils/utils";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";

const FooterAddress = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  const { data: contactUsData = [] } = useGetProtectedApiDataQuery({
    url: "contact_us",
    lang: languageType,
  });

  return (
    <>
      {contactUsData.map((item, index) => (
        <div
          className="col-12 col-sm-12 col-md-3 col-lg-3 print-footm2"
          key={index}
        >
          <div className="titlesec">
            <div className="foot-title">
              {/* {getText(
                "NORTH EASTERN ELECTRIC POWER CORPORATION LTD",
                "नॉर्थ ईस्टर्न इलेक्ट्रिक पावर कॉर्पोरेशन लिमिटेड"
              )}
              <br></br> */}
              {convertSymbolCodes(item.title)}
            </div>
          </div>
          <div className="office-loc">
            <ul>
              <li>
                <a
                  // href="https://maps.app.goo.gl/BNA5XEMXTDxikoZ88"
                  href={item.field_address_board_directoer}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-map-marker" aria-hidden="true"></i>

                  {item?.field_corporate_affairs_address}
                </a>
              </li>

              <li>
                {item.field_corporate_affairs_phone && (
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    <i className="fa fa-phone" aria-hidden="true"></i>{" "}
                    {item?.field_corporate_affairs_phone}
                  </a>
                )}
              </li>

              <li>
                {item.field_corporate_affairs_email && (
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    <i className="fa fa-envelope" aria-hidden="true"></i>{" "}
                    {item?.field_corporate_affairs_email}
                  </a>
                )}
              </li>

              <li>
                {item?.field_corporate_affairs_fax && (
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    <i className="fa fa-print" aria-hidden="true"></i>{" "}
                    {item?.field_corporate_affairs_fax}
                  </a>
                )}
              </li>
            </ul>
          </div>
        </div>
      ))}

      {/* <div className="col-12 col-sm-12 col-md-3 col-lg-3 print-footm3">
        <div className="titlesec">
          <div className="foot-title">
            {getText("Corporate Affairs", "कॉरपोरेट मामले")}
          </div>
        </div>
        <div className="office-loc">
          <ul>
            <li>
              <a
                href="https://maps.app.goo.gl/BNA5XEMXTDxikoZ88"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-map-marker" aria-hidden="true"></i>
               
                {contactUsData[0]?.field_corporate_affairs_address}
              </a>
            </li>
            <li>
              <a href="#" onClick={(e) => e.preventDefault()}>
                <i className="fa fa-envelope" aria-hidden="true"></i>{" "}
                {contactUsData[0]?.field_corporate_affairs_email}
              </a>
            </li>
            <li>
              <a href="#" onClick={(e) => e.preventDefault()}>
                <i className="fa fa-phone" aria-hidden="true"></i>{" "}
                {contactUsData[0]?.field_corporate_affairs_phone}
              </a>
            </li>
          </ul>
        </div>
      </div> */}
    </>
  );
};

export default FooterAddress;
